<template>
  <div>
    <h1>TEST</h1>
    <button class="amap-page-container">
      <el-amap
        ref="map"
        vid="amapDemo"
        :amap-manager="amapManager"
        :center="center"
        :zoom="zoom"
        :plugin="plugin"
        :events="events"
        class="amap-demo"
      />

      <button class="toolbar">
        <button @click="getMap()">get map</button>
      </button>
    </button>
  </div>
</template>

<script>
import VueAMap from 'vue-amap'
import { getMapBikes } from '@/api/bike'
export default {
  name: 'Test',
  data() {
    let amapManager = new VueAMap.AMapManager()
    return {
      points: [],
      amapManager,
      zoom: 12,
      center: [121.59996, 31.197646],
      events: {
        init: (o) => {
          // console.log(o.getCenter())
          // console.log(this.$refs.map.$$getInstance())
          o.getCity(result => {
            // console.log(result)
          })
        },
        'moveend': () => {
        },
        'zoomchange': () => {
        },
        'click': (e) => {
          alert('map clicked')
        },
      },
      plugin: ['ToolBar', {
        pName: 'MapType',
        defaultType: 0,
        events: {
          init(o) {
            // console.log(o)
          },
        },
      }, {
        pName: 'Geolocation',
        events: {
          init(o) {
            // o 是高德地图定位插件实例
            // console.log(o)
            o.getCurrentPosition((status, result) => {
              // 未配置https  定位失败 暂时手动配置
              self.lng = 113.73350255780726
              self.lat = 34.78024666564106
              self.center = [self.lng, self.lat]
              self.loaded = true
              if (result && result.position) {
                self.lng = result.position.lng
                self.lat = result.position.lat
                self.center = [self.lng, self.lat]
                self.loaded = true
                // self.$nextTick()
              }
            })
          },
        },
      } ],
    }
  },
  methods: {
    getMap() {
      // amap vue component
      // console.log(this.amapManager._componentMap)
      // gaode map instance
      // console.log(this.amapManager._map)
    },
    initPage(PointSimplifier) {
      // 创建组件实例
      let _this = this
      var pointSimplifierIns = new PointSimplifier({
        map: this.amapManager._map, // 关联的map
        compareDataItem: function (a, b, aIndex, bIndex) {
          // 数据源中靠后的元素优先，index大的排到前面去
          return aIndex > bIndex ? -1 : 1
        },
        getPosition: function (dataItem) {
          // 返回数据项的经纬度，AMap.LngLat实例或者经纬度数组
          return dataItem.position
        },
        getHoverTitle: function (dataItem, idx) {
          // 返回数据项的Title信息，鼠标hover时显示
          return '序号: ' + idx
        },
        renderOptions: {
          // 点的样式
          pointStyle: {
            fillStyle: 'blue', // 蓝色填充
          },
        },
      })

      // 随机创建一批点，仅作示意
       var data = this.createPoints(_this.amapManager._map.getCenter(), 100000)

      // 设置数据源，data需要是一个数组
     // pointSimplifierIns.setData(this.points)
      pointSimplifierIns.setData(data)

      // 监听事件
      pointSimplifierIns.on('pointClick pointMouseover pointMouseout', function (e, record) {
        console.log(record.data)
      })
    },
    // 仅作示意
    createPoints(center, num) {
      var data = []
      for (var i = 0, len = num; i < len; i++) {
        data.push({
          position: [
            center.getLng() + (Math.random() > 0.5 ? 1 : -1) * Math.random(),
            center.getLat() + (Math.random() > 0.5 ? 1 : -1) * Math.random(),
          ],
        })
      }
      return data
    },
  },
  async created() {
      const {
          data,
      } = await getMapBikes({all: 1})
      // 创建样式对象

      // let AMap = this.amapManager._map
      // console.log(this.amapManager._map)
      // console.log(this.amapManager._componentMap)

//
      var styleObjectArr = [{
          url: 'http://resource.bike.hanyiyun.com/common/low-power.admin.png', // 图标地址 低电量
          size: new AMap.Size(11, 11), // 图标大小
          anchor: new AMap.Pixel(5, 5), // 图标显示位置偏移量，基准点为图标左上角
      }, {
          url: 'http://resource.bike.hanyiyun.com/common/unuse.admin.png', // 图标地址  未使用
          size: new AMap.Size(11, 11), // 图标大小
          anchor: new AMap.Pixel(5, 5), // 图标显示位置偏移量，基准点为图标左上角
      }, {
          url: 'http://resource.bike.hanyiyun.com/common/using.admin.png', // 图标地址  使用中
          size: new AMap.Size(11, 11), // 图标大小
          anchor: new AMap.Pixel(5, 5), // 图标显示位置偏移量，基准点为图标左上角
      }]
      // console.log(styleObjectArr)
    // //
    // // debugger
    var massMarks = new AMap.MassMarks(data,{ zIndex: 5, // 海量点图层叠加的顺序
      zooms: [3, 19], // 在指定地图缩放级别范围内展示海量点图层
      style: styleObjectArr, // 设置样式对象
    })
    // massMarks.setStyle(styleObject)

      // massMarks.setData(data) // 将海量点添加至地图实例
    massMarks.setMap(this.amapManager._map)
    // let _this = this
    // AMapUI.loadUI(['misc/PointSimplifier'], function (PointSimplifier) {
    //   if (!PointSimplifier.supportCanvas) {
    //     alert('当前环境不支持 Canvas！')
    //     return
    //   }

    //   // 启动页面
    //   _this.initPage(PointSimplifier)
    // })
    // console.log(data)
    // this.points = data
  },
}
</script>

<style scoped lang="scss">
.amap-demo {
      height: 800px;
      width: 1200px;
    }
</style>
